import moment from 'moment';
import {
  slotTime,
  cellHeight,
  dayTaskWrapperMaxWidth,
  defaultRowCount,
} from '../../constants/common';
import { modes } from '../../constants/modes';
import { views } from '../../constants/views';
import { getHeight } from '../../utils/helpers';

export const getGridColumn = (index) => {
  switch ((index + 7) % 7) {
    case 0:
      return '2/3';
    case 1:
      return '3/4';
    case 2:
      return '4/5';
    case 3:
      return '5/6';
    case 4:
      return '6/7';
    case 5:
      return '7/8';
    case 6:
      return '8/-1';
  }
};

export const getGridRow = (index) => {
  const i = Math.trunc(index / 7);

  return `${i + 2}/${i + 3}`;
};

export const getGridTemplateColumns = (mode, view) => {
  if (mode === modes.agenda) {
    return '160px 1fr';
  } else {
    const firstColumn = view === views.month ? '2px' : '80px';
    const otherColumns = view === views.day ? '1fr' : 'repeat(7, 1fr)';

    return `${firstColumn} ${otherColumns}`;
  }
};

export const getGridTemplateRows = (mode, view, rowCount, heightTask, calendarData) => {
  if (mode === modes.agenda) {
    return `repeat(${rowCount}, minmax(${cellHeight(heightTask, calendarData)}px, auto))`;
  } else {
    const firstRowSize = view === views.week ? '50px' : '34px';
    const otherRowsSize = view === views.month ? 'minmax(150px, auto)' : `${cellHeight(heightTask, calendarData)}px`;

    return view === views.month
      ? `${firstRowSize} repeat(${rowCount}, ${otherRowsSize})`
      : `${firstRowSize} fit-content(150px) repeat(${rowCount}, ${otherRowsSize})`;
  }
};

export const getRowCount = (mode, view, totalTime) => {
  if (mode === modes.agenda) {
    return view === views.day ? 1 : totalTime;
  } else {
    return view === views.month ? totalTime / 7 : defaultRowCount;
  }
};

export const getGridTemplateColumnsForTasks = (amount) => {
  if (amount <= 2) {
    return '100%';
  }

  if (amount > 2) {
    return 'repeat(2, 1fr)';
  }
};

export const getTaskWrapperStyle = (
  task,
  day,
  taskIndex,
  tasksAmount,
  taskWrapperWidth = 0,
  heightTask, 
  calendarData,
) => {
  const current = day.startOf('day');
  const taskStart = moment(task.fromDate);
  const taskEnd = moment(task.toDate);

  const top = getHeight(taskStart.diff(current, 'minutes'), heightTask, calendarData);

  const height = getHeight(taskEnd.diff(taskStart, 'minutes'), heightTask, calendarData);

  const zIndex = Math.ceil(
    (taskStart.diff(current, 'minutes') / slotTime) * 100 + 2
  );

  const widthCoef =
    taskIndex === tasksAmount - 1 ? 1 / tasksAmount : 17 / (tasksAmount * 10);

  const leftCoef = taskIndex / tasksAmount;

  const left =
    taskWrapperWidth - dayTaskWrapperMaxWidth * tasksAmount > 0
      ? `${dayTaskWrapperMaxWidth * taskIndex + taskIndex * 12}px`
      : `calc((100% - 0px) * ${leftCoef} + 0px)`;

  return {
    top: top + 'px',
    height: height + 'px',
    zIndex: zIndex + taskIndex,
    width: `calc((100% - 0px) * ${widthCoef})`,
    left: left,
  };
};

const getDiff = (obj, unitOfTime) => {
  const start = moment(obj.fromDate);
  const end = moment(obj.toDate);

  return end.diff(start, unitOfTime);
};

export const sortDayTasks = (a, b) =>
  getDiff(b, 'minutes') - getDiff(a, 'minutes');

export const generateDayTasks = (tasks) => {
  const filteredTasks = tasks.filter((task) => task.visible).sort(sortDayTasks);

  const decomposedTasks = {};

  filteredTasks.forEach((task) => {
    const index = moment(task.fromDate).format('YYYY-MM-DD, HH:mm');
    let currentTasks = decomposedTasks[index];

    if (!currentTasks) {
      decomposedTasks[index] = [task];
    } else {
      decomposedTasks[index].push(task);
    }
  });

  return { tasks: Object.values(decomposedTasks) };
};

export const getTime = (index) => {
  const time = moment().hours(index).minutes(0);

  return time.format('HH:mm');
};

export const getFakeTasks = (num) => {
  const arr = [];
  for (let i = 0; i < num; i++) {
    const task = {
      id: i,
      requestId: 466599,
      fromDate: '2023-05-24T04:00:00.000Z',
      toDate: '2023-05-24T12:00:00.000Z',
      worker: {
        id: 45,
        phone: '9323232177',
        surName: 'Программист',
        firstName: 'Сергей',
        patrName: 'Геннадьевич',
        fullName: 'Программист Сергей Геннадьевич',
      },
      streetName: 'Демонстрационная',
      building: '2',
      flat: '2',
      fullAddress: 'Демонстрационная, 2, 2',
      index: 0,
      visible: true,
    };

    arr.push(task);
  }

  return arr;
};
